import { Link } from "react-router-dom";

const quickItems = [
  { label: "今日热榜", icon: "ri-fire-line", to: "/category/news" },
  { label: "看视频", icon: "ri-play-circle-line", to: "/category/entertainment" },
  { label: "找学习", icon: "ri-graduation-cap-line", to: "/category/study" },
  { label: "查地图", icon: "ri-map-pin-line", to: "/category/travel" },
  { label: "买点啥", icon: "ri-shopping-cart-2-line", to: "/category/shopping" },
  { label: "开发者", icon: "ri-code-s-slash-line", to: "/category/tech" },
];

export default function QuickLinks() {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4">
      <h2 className="flex items-center gap-1.5 font-heading font-bold text-sm text-foreground-950 mb-3">
        <i className="ri-flashlight-line text-primary-500" />
        场景直达
      </h2>
      <div className="grid grid-cols-2 gap-2">
        {quickItems.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            className="flex items-center gap-2 px-2.5 py-2 rounded-md bg-background-100 hover:bg-primary-50 hover:text-primary-700 text-xs text-foreground-700 transition-colors cursor-pointer"
          >
            <i className={`${item.icon} text-base text-primary-500`} />
            <span className="truncate">{item.label}</span>
          </Link>
        ))}
      </div>
      <div className="mt-3 p-3 rounded-md bg-primary-50 border border-primary-100">
        <p className="text-[11px] text-primary-800 leading-5">
          <span className="font-medium">小提示：</span>
          使用顶部搜索框输入关键词，可模糊匹配网站名称、域名与标签。
        </p>
      </div>
    </div>
  );
}